import angular from 'angular';

import component from './experience-summary.component';

const ExperienceSummary = angular
    .module('control-room.experience-promoter.components.experience-manage.components.experience-summary', [])
    .component('crExperienceSummary', component);

export default ExperienceSummary;
